import { Container, Grid, Typography } from "@mui/material";
import ContentHeader from "../../components/layout/ContentHeader/ContentHeader";
import Section from "../../components/layout/Section/Section";
import { PAGE } from "../../constants/page";
import ArrowButton from "../../components/ui/ArrowButton/ArrowButton";
import NavBreadcrumbs from "../../components/navigation/NavBreadcrumbs/NavBreadcrumbs";

interface Props {
  children?: React.ReactElement<unknown>;
}

export default function NotFound(props: Props) {
  return (
    <>
      <Section color="dark">
        <ContentHeader title={PAGE.ERROR.NAME} subTitle={PAGE.ERROR.TEXT} />
      </Section>

      <Section color="light">
        <Container>
          <Grid size={{ sm: 12, lg: 12 }} sx={{ marginTop: '100px', marginBottom: '100px' }}>
            <Typography variant="body1" fontSize={'1.25rem'} marginBottom={'2rem'}>
              お探しのページが見つかりませんでした。
            </Typography>
            <Typography variant="body1">
              お探しのページは、削除・移動・変更されたか、アドレスが異なっているなどの理由で見つかりませんでした。<br />
              お手数ですが、ページ上部・下部のナビゲーションか、トップページより必要な情報をお探しください。
            </Typography>
          </Grid>
        </Container>
      </Section >

      <Section height="100px" color="light">
        <Container>
          <Grid>
            <Grid size={12} sx={{ textAlign: 'center' }}>
              <ArrowButton label={PAGE.TOP.NAME} href={PAGE.TOP.PATH} isLeft />
            </Grid>
          </Grid>
        </Container >
      </Section>
    </>
  )
}